/* eslint-disable */
import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { loaderStore } from './loaderStore'

function TopLoader({ message }) {
    const idRef = useRef(null)

    useEffect(() => {
        idRef.current = loaderStore.register(message)
        return () => {
            if (idRef.current) {
                loaderStore.unregister(idRef.current)
            }
        }
    }, [])

    useEffect(() => {
        if (idRef.current) {
            loaderStore.update(idRef.current, message)
        }
    }, [message])

    return null
}

TopLoader.propTypes = {
    message: PropTypes.string,
}

TopLoader.defaultProps = {
    message: 'Loading...',
}

export default TopLoader
